import { Add } from '@mui/icons-material'
import { Button, Stack, Tooltip, Typography } from '@mui/material'

interface Props {
  testId?: string
  label: string
  action: {
    label: string
    tooltip: string
    disabledTooltip: string
    onClick: () => void
    disabled?: boolean
  }
}

export function FormHeader(props: Props) {
  const { testId, label, action } = props

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      height={31}
      data-testid={testId}
    >
      <Typography noWrap variant="body1">
        {label}
      </Typography>
      <Tooltip title={action.disabled ? action.disabledTooltip : action.tooltip}>
        <span>
          <Button
            onClick={action.onClick}
            disabled={action.disabled}
            data-testid={`${testId}-add-button`}
            data-trackid={`${testId}-add-button`}
            variant="outlined"
            size="small"
          >
            <Add /> {action.label}
          </Button>
        </span>
      </Tooltip>
    </Stack>
  )
}
